export const takerFieldTypes = {
  text: 'taker_field_text',
  select: 'taker_field_select'
};
